import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";
import { formatViews } from "@/lib/media";

interface MediaCardProps {
  item: MediaItem;
  className?: string;
}

export default function MediaCard({ item, className = "" }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className={`group block rounded-lg ${className}`}
      aria-label={`查看《${item.title}》详情`}
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg border border-background-800 bg-background-800">
        <img
          src={item.cover}
          alt={`《${item.title}》封面海报`}
          title={`${item.title} - 免费播放片大片`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/25 to-transparent"></div>

        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-background-950/75 px-1.5 py-0.5 text-xs font-medium text-accent-400 backdrop-blur">
          <i className="ri-star-fill text-[11px]"></i>
          {item.rating.toFixed(1)}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-primary-500/90 px-1.5 py-0.5 text-[11px] text-foreground-50">
          {item.type === "tv" ? `${item.episodes?.length ?? 0} 集` : "电影"}
        </span>

        <div className="absolute inset-x-0 bottom-0 p-2.5">
          <h3 className="truncate font-heading text-sm font-semibold text-foreground-50 md:text-base">
            {item.title}
          </h3>
          <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[11px] text-foreground-300 md:text-xs">
            <span>{item.year}</span>
            <span className="text-foreground-600">·</span>
            <span className="truncate">{item.genres.slice(0, 2).join(" / ")}</span>
          </div>
          <div className="mt-1 flex items-center gap-1 text-[11px] text-foreground-400 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <i className="ri-fire-line text-accent-400"></i>
            {formatViews(item.views)} 热度
          </div>
        </div>
      </div>
    </Link>
  );
}